/*
 * KAPstat platform — router shell.
 * Copyright (c) 2026 Eddlynn Edtech Private Limited. All rights reserved.
 */
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home.jsx';
import Studies from './StudiesPage.jsx';
import StudyPage from './StudyPage.jsx';
import Learn from './Learn.jsx';
import Auth from './Auth.jsx';

// The investigator console (+ xlsx/analytics) is code-split so participants
// never download it.
const Console = lazy(() => import('./Console.jsx'));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ padding: 40, textAlign: 'center', color: '#6b7686' }}>Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studies" element={<Studies />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/study/:slug" element={<StudyPage />} />
          <Route path="/signin" element={<Auth mode="signin" />} />
          <Route path="/signup" element={<Auth mode="signup" />} />
          <Route path="/console" element={<Console />} />
          <Route path="/console/:slug" element={<Console />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
